import { MessageCircle } from "lucide-react";
import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import Marquee from "@/components/Marquee";
import Services from "@/components/Services";
import Manifesto from "@/components/Manifesto";
import Gallery from "@/components/Gallery";
import SailingFleet from "@/components/SailingFleet";
import Footer from "@/components/Footer";
import { WHATSAPP_URL } from "@/i18n";

export default function Home() {
  return (
    <div data-testid="home-page" className="bg-lake-deep">
      <Navbar />
      <Hero />
      <Marquee />
      <Services />
      <Gallery />
      <SailingFleet />
      <Manifesto />
      <Footer />
      <a
        data-testid="whatsapp-floating-cta"
        href={WHATSAPP_URL}
        target="_blank"
        rel="noopener noreferrer"
        aria-label="WhatsApp"
        className="fixed bottom-6 right-6 z-50 w-14 h-14 rounded-full bg-[#25D366] text-white flex items-center justify-center shadow-[0_10px_30px_-8px_rgba(37,211,102,0.6)] hover:scale-110 transition-transform duration-300"
      >
        <MessageCircle className="w-6 h-6" />
      </a>
    </div>
  );
}
